import "./LeafTileDivider.scss";

const LeafTileDivider = () => {
  return <div className="divider-line" />;
};

export default LeafTileDivider;
